import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Grievance() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Grievance</strong></p>
              <div className="clear"></div>
            </span>
            <div id="facil">
              <div style={{ textAlign: 'left' }}></div>
              <table width="523" border="0" align="center" cellPadding="0" cellSpacing="0" style={{ border: '1px solid #eeeeee' }}>
                <tbody>
                  <tr>
                    <td width="3" height="30">&nbsp;</td>
                    <td width="518" height="30"><table width="546" align="left" cellPadding="0" cellSpacing="0">
                      <tbody>
                        <tr>
                          <td width="512" style={{ textAlign: 'left', verticalAlign: 'top' }}><p style={{ textAlign: 'center' }}><u style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>GRIEVANCE REDRESSAL SYSTEM(GRS) AT OUR POLYTECHNIC</u><br />
                            <br />
                            As per the guidelines of AICTE, (Gazette notification Dtd: 25th May 2012) we have established an Grievance redressal System in order to ensure transparency in admissions and with Paramount Objective of preventing unfair practices and to provide a mechanism to students/parents/staff members for redressal of their grievances .<br />
                            <br />
                            Concerned individuals (Students/Parents/Staff members) are requested to call on our college Phone No. 0820-2574049 / 8762070232 or visit our college office for appointment/details to submit your grievance/feedback. Alternatively they can also visit our online Grievance Redressal System available at our URL -<a href="http://isrpolytechnic.edugrievance.com/" target="new" className="inlinks" rel="noopener noreferrer"> isrpolytechnic.edugrievance.com</a></p></td>
                        </tr>
                      </tbody>
                    </table><p>&nbsp;</p></td>
                  </tr>
                </tbody>
              </table>
              <br />
              <p style={{ textAlign: 'left' }}><br />
                <br />
                <strong><br />
                </strong></p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Grievance;
